import { createFileRoute } from '@tanstack/react-router'
import { shoppingListId } from '_/features/shopping/domain/types'
import { ShoppingListPage } from '_/features/shopping/ui/pages/shopping-list-page'

const ShoppingListRoute = () => {
	const { listid } = Route.useParams()
	return <ShoppingListPage listId={shoppingListId(listid)} />
}

export const Route = createFileRoute('/_authenticated/shopping/$listid')({
	staticData: { title: 'shopping_title' },
	component: ShoppingListRoute,
})
